import React from "react";
import { IUniform } from "../../interfaces/IUniform";
import Button from "../Button.tsx";

interface UniformFormProps {
  uniform: IUniform;
  onSave: (uniform: IUniform) => void;
  onCancel: () => void;
  isEditing?: boolean;
}

const UniformForm: React.FC<UniformFormProps> = ({
  uniform,
  onSave,
  onCancel,
  isEditing = false,
}) => {
  const [formData, setFormData] = React.useState<IUniform>({
    ...uniform,
    unitPrice: typeof uniform.unitPrice === 'string' ? parseFloat(uniform.unitPrice) : uniform.unitPrice
  });

  const handleInputChange = (field: keyof IUniform, value: string | number) => {
    setFormData(prev => ({
      ...prev,
      [field]: value,
    }));
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onSave(formData);
  };

  return (
    <div>
      <form onSubmit={handleSubmit}>
        <div className="row">
          <div className="col-md-6">
            <div className="mb-3">
              <label className="form-label fw-semibold">
                Nombre de la prenda <span className="text-danger">*</span>
              </label>
              <input
                type="text"
                className="form-control"
                placeholder="Ej: Camisa, Pantalón, Zapatos"
                value={formData.name}
                onChange={(e) => handleInputChange('name', e.target.value)}
                required
              />
            </div>
          </div>
          <div className="col-md-6">
            <div className="mb-3">
              <label className="form-label fw-semibold">
                Precio unitario <span className="text-danger">*</span>
              </label>
              <div className="input-group">
                <span className="input-group-text">$</span>
                <input
                  type="number"
                  className="form-control"
                  placeholder="0.00"
                  step="0.01"
                  min="0"
                  value={formData.unitPrice}
                  onChange={(e) => handleInputChange('unitPrice', parseFloat(e.target.value) || 0)}
                  required
                />
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            <div className="mb-3">
              <label className="form-label fw-semibold">
                Descripción detallada <span className="text-danger">*</span>
              </label>
              <textarea
                className="form-control"
                placeholder="Describe las características, materiales, tallas disponibles, etc."
                value={formData.description}
                onChange={(e) => handleInputChange('description', e.target.value)}
                rows={3}
                required
              />
            </div>
          </div>
        </div>
        <div className="d-flex justify-content-end gap-2 mt-3">
          <Button
            title="Cancelar"
            variant="secondary"
            type="button"
            onClick={onCancel}
          />
          <Button
            title={isEditing ? "Actualizar" : "Agregar"}
            variant="azul"
            type="submit"
          />
        </div>
      </form>
    </div>
  );
};

export default UniformForm;
